import React, { useState, useEffect } from "react";
import {
  Container,
  MainTitle,
  Title,
  Body,
  ContentContainer,
  ImageTitle,
} from "./style";
import MapY from "../../Map/MapModal";
import ImageBlock from "./ImageGallery";
import { useShowModal } from "../../../hooks";
import Description from "../TaskCard/Description";
import CardTitle from "../TaskCard/CardMainTitle";

import WorkFooter from "../TaskCard/WorkFooter";
import moment from "moment";

const TaskCard = ({
  data = {},
  medium,
  titleLeft,
  canDeleteImage,
  handleDeleteImage,
  handleDeleteOldImage,
  handleDescription,
  errorHelper,
  description,
  allowEdit,
  borderLess,
  workTitle,
}) => {
  const { showBlured } = useShowModal();
  const [mainImage, setMainImage] = useState({});
  const [oldMainImage, setOldMainImage] = useState({});
  const [geoLocation, setGeoLocation] = useState([]);
  useEffect(() => {
    if (
      data?.media !== undefined &&
      data?.media !== null &&
      data?.media?.length > 0
    ) {
      const latLng = [data?.media[0]?.lat, data?.media[0]?.lng];
      if (latLng !== undefined && latLng !== null) {
        setGeoLocation([data?.media[0]?.lat, data?.media[0]?.lng]);
        setMainImage(data?.media && data?.media[0]);
      }
    }
    if (
      data?.oldMedia !== undefined &&
      data?.oldMedia !== null &&
      data?.oldMedia?.length > 0
    ) {
      setOldMainImage(data?.oldMedia && data?.oldMedia[0]);
    }
  }, [data]);

  const handleShowModal = () => {
    showBlured({
      title: "Тадбир ўтказилган жой",
      maxWidth: "1200px",
      height: "600px",
      withHeader: false,
      body: () => <MapY latLang={geoLocation} />,
    });
  };

  const checkActive = (image) => {
    if (image === mainImage?.image) return true;
  };

  const handleMainImage = (image) => {
    const latLng = [image?.lat, image?.lng];
    setGeoLocation(latLng);
    setMainImage(image);
  };
  return (
    <Container medium={medium} borderLess={borderLess}>
      <MainTitle titleLeft={titleLeft}>
        <Title titleLeft={titleLeft}>
          <CardTitle data={data} />
        </Title>
      </MainTitle>
      <Body medium={medium}>
        <ContentContainer>
          <div>
            {data?.oldMedia.length !== 0 && (
              <ImageTitle>
                Ҳозир: {moment(data?.createdAt).format("YYYY-MM-DD")}{" "}
              </ImageTitle>
            )}
            <ImageBlock
              medium={medium}
              imageData={data?.media}
              videos={data?.video}
              checkActive={checkActive}
              handleMainImage={handleMainImage}
              mainImage={mainImage}
              canDeleteImage={canDeleteImage}
              deleteImage={handleDeleteImage}
            />
          </div>
          {data?.oldMedia.length !== 0 ? (
            <>
              <div>
                <ImageTitle>
                  Олдин :{" "}
                  {data?.workYear &&
                    moment(data?.workYear.toString()).format("YYYY")}
                </ImageTitle>
                <ImageBlock
                  medium={medium}
                  imageData={data?.oldMedia}
                  checkActive={checkActive}
                  handleMainImage={(image) => setOldMainImage(image)}
                  mainImage={oldMainImage}
                  videos={data.oldVideo}
                  canDeleteImage={canDeleteImage}
                  deleteImage={handleDeleteOldImage}
                />
              </div>
            </>
          ) : (
            <WorkFooter
              borderB
              data={data}
              disabledCheckbox
              handleShowModal={handleShowModal}
            />
          )}
        </ContentContainer>
        {data?.oldMedia.length !== 0 ? (
          <ContentContainer>
            <WorkFooter
              borderB
              data={data}
              disabledCheckbox
              handleShowModal={handleShowModal}
              // objectsList={obJectHandler()}
            />
            <Description
              allowEdit={allowEdit}
              handleShowModal={handleShowModal}
              mainworkData={data.desc}
              medium={medium}
              workId={data._id}
              title={data?.subCategoryName}
              value={description}
              onChange={handleDescription}
              errorHelper={errorHelper}
              changeTitle
              workTitle={workTitle}
            />
          </ContentContainer>
        ) : (
          <Description
            allowEdit={allowEdit}
            handleShowModal={handleShowModal}
            mainworkData={data.desc}
            medium={medium}
            workId={data._id}
            title={data?.subCategoryName}
            value={description}
            onChange={handleDescription}
            errorHelper={errorHelper}
          />
        )}
      </Body>
    </Container>
  );
};

export default React.memo(TaskCard);
